module.exports = __webpack_public_path__ + "img/wallet-balance-icon.c5d952d8.svg";